/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const sendPushCampaignV1BodySchema = z.object({
  audience: z.enum(['all', 'enabled', 'single']),
  targetUserId: z.string().min(1).optional(),
  title: z.string().min(1).max(120),
  body: z.string().min(1).max(500),
  url: z.string().min(1).max(500).optional(),
});

export type ISendPushCampaignV1Body = z.infer<typeof sendPushCampaignV1BodySchema>;
